import type { LookInfo, PurchaseResponse } from "../handlers/types";
import { formatTimeFromMs } from "./timeUtils";

export type WeeklySaleInfo = PurchaseResponse["weeklySale"];

export const WEEKLY_SALE_SECOND_MS = 1000;

export interface WeeklySaleState {
  info: WeeklySaleInfo | null;
  items: LookInfo[];
}

export const EMPTY_WEEKLY_SALE: WeeklySaleState = {
  info: null,
  items: [],
};

export function buildWeeklySaleState(
  response: PurchaseResponse
): WeeklySaleState {
  const weeklySaleItems = (response.looks ?? []).filter(
    (look) => look.weeklyLimited
  );

  return {
    info: response.weeklySale ?? null,
    items: weeklySaleItems,
  };
}

export function getWeeklySaleCountdown(secondsRemaining: number): string {
  return formatTimeFromMs(
    Math.max(secondsRemaining, 0) * WEEKLY_SALE_SECOND_MS
  );
}

export function getWeeklySaleItemTitle(
  look: LookInfo,
  translate: (key: string, options?: Record<string, unknown>) => string
): string {
  const parsedId = look.id.split("_").join(" ");

  return translate(parsedId, { defaultValue: parsedId });
}
